import ReportingSvg from 'assets/icons/navigation/reporting.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(ReportingSvg, {
  displayName: 'ReportingIcon',
});
